import { useQuery } from "react-query";
import { getSeparationReasons } from "../../../../../actions/Employees";

export const useGetSeparationReason = () => {
  return useQuery("GetSeparationReasons", getSeparationReasons, {
    refetchOnWindowFocus: false,
  });
};
